import { Component, OnInit, ViewChild } from '@angular/core';
import { TabViewModule } from 'primeng/tabview';
import { ActividadComponent } from './actividad/actividad.component';
import { ActivatedRoute } from '@angular/router';
import { TramiteHistorialComponent } from './tramite-historial/tramite-historial.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FacturaComponent } from './factura/factura.component';
import { PagoComponent } from './pago/pago.component';
import { EmpresaInfoComponent } from './empresa-info/empresa-info.component';

@Component({
  selector: 'app-admin-actividad',
  standalone: true,
  imports: [
    TabViewModule, TranslateModule, CommonModule, PagoComponent,
    ActividadComponent, TramiteHistorialComponent, FacturaComponent, EmpresaInfoComponent
  ],
  templateUrl: './admin-actividad.component.html',
  styleUrls: ['./admin-actividad.component.scss', '../../../../assets/styles/style.mantenimiento.scss']
})
export class AdminActividadComponent {
  tramRegistroId !: number;
  actividadId !: number;
  activeTabIndex: number = 0;
  title: string ='';
  private _requierePago: boolean = false;
  private _empresaId !: number;

  get requierePago(): boolean {
    return this._requierePago;
  }

  set requierePago(value: boolean) {
    this._requierePago = value;
    this.tabs[2].visible = value;
    this.tabs[3].visible = value;
  }

  get empresaId(): number {
    return this._empresaId;
  }

  set empresaId(value: number) {
    this._empresaId = value;   
    this.tabs[4].visible = (value !== undefined && value !== null) ? true : false;    
  }

  tabs = [{name: 'actividad', label: 'common.actividadVigente', visible: true}, 
    {name: 'historial', label: 'common.historialDelTrámite', visible: true}, 
    {name: 'factura', label: 'common.factura', visible: false}, 
    {name: 'pago', label: 'common.pago', visible: false}, 
    {name: 'empresa', label: 'common.empresa', visible: false}];

  @ViewChild(ActividadComponent) actividadComponent !: ActividadComponent;
  @ViewChild(TramiteHistorialComponent) TramiteHistorialComponent !: TramiteHistorialComponent
  @ViewChild(FacturaComponent) facturaComponent !: FacturaComponent
  @ViewChild(PagoComponent) pagoComponent !: PagoComponent
  @ViewChild(EmpresaInfoComponent) empresaComponent !: EmpresaInfoComponent
  
  constructor(private readonly _route: ActivatedRoute) {
    this.actividadId = Number(this._route.snapshot.params['actividadId']);    
    this.tramRegistroId = Number(this._route.snapshot.params['tramRegistroId']);    
  }

  activeIndexChange(index: number) {
    const visibleTabs = this.tabs.filter(t => t.visible);
    const tab = visibleTabs[index];

    if (tab.name === 'actividad')
      this.actividadComponent.getActividadInfo();
    else if( tab.name === 'historial')
      this.TramiteHistorialComponent.getHistorial();
    else if( tab.name === 'factura')
      this.facturaComponent.getFacturaInfo();
    else if( tab.name === 'pago')
      this.pagoComponent.getPagoInfo();
    else if( tab.name === 'empresa')
      this.empresaComponent.getEmpresaInfo();

  }
}
